import SearchInputWithTypes from '@/shared/SearchInputWithTypes/SearchInputWithTypes';
import { StyledSearchThemes } from './SearchThemes.styled';
import useSearchThemes from './useSearchThemes.hook';
import LanguageSelector from '@/shared/LanguageSelector/LanguageSelector';

export default function SearchThemes({
  className,
  teacherProButtons,
  isPublic,
}) {
  const { state, actions } = useSearchThemes();

  return (
    <StyledSearchThemes className={className}>
      {teacherProButtons ? (
        <div className="left-content">{teacherProButtons}</div>
      ) : null}
      {isPublic ? <LanguageSelector /> : null}
      <SearchInputWithTypes
        value={state.searchText}
        onChange={actions.setSearchText}
        selectedActivityType={state.activityType}
        onActivityTypeChange={actions.setActivityType}
        allowClear
      />
    </StyledSearchThemes>
  );
}
